export default "__VITE_ASSET__BWc0M_Fm__"